module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Hv.17861fe.ttf";